import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { KnowWhyAPIReponseType } from '../../types/mutual-fund-detail.types'
import { KnowWhyBottomSheetContent } from '../know-why/KnowWhyBottomSheetContent'
import { KNOW_WHY_REASONS_HEADING_ID } from '../know-why/constants'
import Button from '../ui-components/Button'
import { getBottomPadding } from '../../utils/sessionStorage'

export const KnowWhyBottomSheet = ({
  onDismiss,
  ScreenName,
  knowWhyData
}: {
  onDismiss: () => void
  ScreenName: string
  knowWhyData: KnowWhyAPIReponseType
}) => {
  const heading = 'Know Why'

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])

  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      headingTitleId={KNOW_WHY_REASONS_HEADING_ID}
      bottomSheetBodyClassName='!px-0 !bg-[#F0F4F7]'
      bottomSheetHeadClassName='!pt-0'
      bottomSheetCtas={
        <div
          style={{
            background: 'linear-gradient(180deg, rgba(240, 244, 247, 0.00) 0%, #F0F4F7 60.38%)',
            paddingBottom: `${getBottomPadding() + 8}px`
          }}
          className='w-full px-5 pt-9'
        >
          <Button
            isFullWidth
            label='Close'
            onClick={onDismiss}
            buttonClassName='w-full !h-[48px] !bg-white !text-[#232323] !text-[16px] !border-[1px] !border-[#F0F4F7] !border-solid'
          />
        </div>
      }
      bottomSheetClassName='bg-[#F0F4F7]'
      bottomSheetCtaWrapperClassName='!bg-transparent'
      bottomSheetCtaClassName='!px-0 !py-0 !bg-none'
    >
      {knowWhyData && <KnowWhyBottomSheetContent knowWhyData={knowWhyData} ScreenName={ScreenName} />}
    </BottomSheetContent>
  )
}
